import logo from './logo.svg';
import './App.css';
import { useContext, useEffect } from 'react';
import { useCookies } from "react-cookie";
import { BrowserRouter as Router, Routes, Route, useParams, useLocation } from "react-router-dom";
import Home from './screens/home';
import Shop from './screens/shop';
import MyCart from './screens/my-cart';
import Checkout from './screens/checkout';
import OrderSuccess from './screens/order-success';
import WigRevamp from './screens/wig-revamp-services';
import ShippingPolicy from './screens/shipping-policy';
import RefundPolicy from './screens/refund-policy';
import AboutUs from './screens/about';
import PageNotFound from './screens/not-found';
import CapSize from './screens/CapSize';
import TostMessageComponent from "./TostMessageComponent/TostMessageComponent";
import { base_url } from './url_variables';
import axios from 'axios';

function App() {
  const [cookies, setCookie, removeCookie] = useCookies();

  useEffect(() => {
    getMisc()
  }, [])

  async function getMisc() {
    const formData = new FormData();
    try {
        const response = await axios.post(base_url + '/get_misc.php', formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
        if (response.data.status) {
          if (cookies?.user_country == undefined || cookies?.user_country == null) {
            setCookie("user_country", response.data.user_country, {
              path: "/",
              maxAge: 60 * 60 * 24, // 24 hours (SECONDS)
              secure: true,
              sameSite: "strict"
            });
          }
          setCookie("exchange_rate", response.data.exchange_rate, {
            path: "/",
            maxAge: 60 * 60 * 24, // 24 hours (SECONDS)
            secure: true,
            sameSite: "strict"
          });
          setCookie("categories", response.data.categories, {
              path: "/",
              maxAge: 60 * 60 * 24, // 24 hours (SECONDS)
              secure: true,
              sameSite: "strict"
          });
        } else {

        }
    } catch (error) {

    }
  }

  return (
    <div>
      {/* <ScrollToTop /> */}
      <TostMessageComponent />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/shop-now" element={<Shop />} />
        <Route path="/shop-now/:lnk_prod_id/:lnk_prod_name" element={<Shop />} />
        <Route path="/my-cart" element={<MyCart />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/checkout/:link_reference" element={<Checkout />} />
        <Route path="/order-success/:reference" element={<OrderSuccess />} />
        <Route path="/wig-revamp-service" element={<WigRevamp />} />
        <Route path="/shipping-policy" element={<ShippingPolicy />} />
        <Route path="/refund-policy" element={<RefundPolicy />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/book-fitting" element={<CapSize />} />

        <Route path="/*" element={<PageNotFound />} />
      </Routes>
    </div>
  );
}

export default App;
